import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
export const getTotalPayment = createAsyncThunk('appStripeIntegration/getTotalPayment', async (GetPayment) => {
        
    const response = await axios.post('https://api.zasway.com:8443/Passenger/GetTableSummaryFinancialInfo', GetPayment, {mode:'cors'})
     
    return response.data 

    })
    export const appStripeIntegrationSlice = createSlice({
        name: 'appStripeIntegration',
        initialState: {
          data: []
        },
        reducers: {},
        extraReducers: builder => {
          builder
          .addCase(getTotalPayment.fulfilled, (state, action) => {
            state.data = action.payload.data
          })
        
        }
      })
       export default appStripeIntegrationSlice.reducer